import React, { useState, useEffect } from 'react';

import api from 'services/api';
import { useDebounce } from 'hooks/useDebounce';

import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import Button from 'components/Button';
import Text from 'components/Text';
import { Input } from 'components/Fields';

import ModalCreateColor from 'components/ModalCreateColor';

import Header from '../Header';
import ModalDeleteOrIsActive, { Types } from '../ModalDeleteOrIsActive';

import { Container } from './styles';
import { List, Item, ContainerActions, SwitchTheme } from '../styles';

interface IList {
  id: number;
  color: string;
  group: string;
  isActive?: boolean;
}

const endpoint = '/colors';

const Color: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [list, setList] = useState<IList[]>([]);
  const [loading, setLoading] = useState(false);
  const [openModalIsActive, setOpenModalIsActive] = useState<Types | boolean>(
    false,
  );
  const [colorSelected, setColorSelected] = useState<any>(false);

  const getColors = async () => {
    setLoading(true);

    const newList: IList[] = await api.get(`${endpoint}?color=${search}`);

    setList(newList);

    setLoading(false);
  };

  const autoSave = useDebounce(search);

  const saveChange = async () => {
    getColors();
  };

  useEffect(() => {
    saveChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSave]);

  return (
    <Container>
      <ModalCreateColor
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={() => getColors()}
      />

      <Header
        onCreate={() => setModalOpen(true)}
        title="Color management"
        titleCreate="Create new color"
      />

      {!!openModalIsActive && (
        <ModalDeleteOrIsActive
          type={openModalIsActive as Types}
          endpoint={endpoint}
          itemName={colorSelected.color}
          id={colorSelected.id}
          isActive={colorSelected.isActive}
          onClose={() => setOpenModalIsActive(false)}
          onCreated={() => {
            if (openModalIsActive === Types.DELETE) {
              setList(list.filter(i => i.id !== colorSelected.id));
            }
            if (openModalIsActive === Types.ISACTIVE) {
              const newList = list;

              newList[colorSelected.index] = {
                ...newList[colorSelected.index],
                isActive: !colorSelected.isActive,
              };

              setList(newList);
            }
            setOpenModalIsActive(false);
          }}
        />
      )}

      <Input
        name="search"
        onChange={e => setSearch(e.target.value)}
        value={search}
        placeholder="Search color"
        width="100%"
        dataTest="search"
        leftContent={
          <Icon
            icon="search"
            color="grayLightText"
            width="18px"
            height="18px"
          />
        }
      />
      <List>
        {loading ? (
          <GridFlex justifyContent="center" alignItems="center">
            <Spinner />
          </GridFlex>
        ) : (
          <>
            {list.map(({ color, id, isActive }, index) => (
              <Item key={id}>
                <Text fontSize={14} fontWeight="normal" color="black">
                  {color}
                </Text>
                <ContainerActions>
                  <SwitchTheme
                    checked={!isActive}
                    data-testid={`button-row-isActive-${id}`}
                    onClick={() => {
                      setOpenModalIsActive(Types.ISACTIVE);
                      setColorSelected({ color, id, isActive, index });
                    }}
                  />
                  <Button
                    width="95px"
                    padding="6px 30px"
                    data-testid={`button-row-delete-${id}`}
                    onClick={() => {
                      setOpenModalIsActive(Types.DELETE);
                      setColorSelected({ color, id, isActive, index });
                    }}
                  >
                    Delete
                  </Button>
                </ContainerActions>
              </Item>
            ))}
          </>
        )}
      </List>
    </Container>
  );
};

export default Color;
